export class BackgroundTask {

    constructor (public task: (index) => boolean | Promise<boolean>, public interval: number) {
        
    }

    async run () {
        let index = 0;
        while (await this.task(index++)) await new Promise(resolve => setTimeout(resolve, this.interval));
    }
}